export default function Input(props) {
	let {variant} = props;
	let classes = VARIANTS[variant || 'input']?.replace(/\s+/g, ' ');
	return <input {...props}
								className={classes || VARIANTS['input']}/>
}

export const VARIANTS = {
	input: `
		!dxp-border-gray-300
		!dxp-leading-5
		!dxp-m-0
		!dxp-px-3.5
		!dxp-py-4
		!dxp-rounded-lg
		!dxp-text-sm
		!dxp-w-full
		focus-visible:!dxp-shadow-none
		focus-visible:!dxp-border
		focus-visible:!dxp-border-1
		focus-visible:!dxp-border-purple
		focus:!dxp-shadow-none
		focus:!dxp-border
		focus:!dxp-border-1
		focus:!dxp-border-purple
		!placeholder:dxp-text-sm
		!placeholder:dxp-text-tundora
	`,
	small: `
		!dxp-border-gray-300
		!dxp-leading-5
		!dxp-m-0
		!dxp-px-3.5
		!dxp-py-2
		!dxp-rounded-lg
		!dxp-text-sm
		!dxp-w-full
		focus-visible:!dxp-shadow-none
		focus-visible:!dxp-border
		focus-visible:!dxp-border-1
		focus-visible:!dxp-border-purple
		focus:!dxp-shadow-none
		focus:!dxp-border
		focus:!dxp-border-1
		focus:!dxp-border-purple
		!placeholder:dxp-text-sm
		!placeholder:dxp-text-tundora
	`,
}
